'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = clearRenderer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function clearRenderer() {
	return _react2.default.createElement('span', {
		className: 'Select-clear',
		dangerouslySetInnerHTML: { __html: '&times;' }
	});
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-select/lib/utils/defaultClearRenderer.js
 ** module id = 1149
 ** module chunks = 3
 **/